import { render, staticRenderFns } from "./HowToBuyEthereumWithUSD.vue?vue&type=template&id=a6dcd402&scoped=true&"
import script from "./HowToBuyEthereumWithUSD.vue?vue&type=script&lang=js&"
export * from "./HowToBuyEthereumWithUSD.vue?vue&type=script&lang=js&"
import style0 from "./HowToBuyEthereumWithUSD.vue?vue&type=style&index=0&id=a6dcd402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dcd402",
  null
  
)

export default component.exports